/* SantoLoco extras: signup popup, countdown timer, shop-the-look hotspots */
(function () {
  if (window.__slExtras) return;
  window.__slExtras = true;

  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }

  /* ---------- Signup popup ---------- */
  function initPopup(dlg) {
    if (!dlg || dlg.__sl) return;
    dlg.__sl = true;
    var phone = window.matchMedia('(max-width: 749px)');
    var design = dlg.getAttribute('data-design') === 'true';
    var delay = Number(dlg.getAttribute('data-delay') || 12) * 1000;
    var days = Number(dlg.getAttribute('data-days') || 14);
    var KEY_SUB = 'sl_pop_subscribed', KEY_SEEN = 'sl_pop_closed_at';

    function open() {
      if (dlg.open) return;
      try { phone.matches || !dlg.showModal ? dlg.show() : dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    }
    function close() {
      store(KEY_SEEN, String(Date.now()));
      try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
    }
    dlg.querySelectorAll('[data-sl-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('cancel', function () { store(KEY_SEEN, String(Date.now())); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    var form = dlg.querySelector('form');
    if (form) form.addEventListener('submit', function () { store('sl_pop_sent', '1'); });

    // Came back after submitting the popup form: show the thank-you (or the error) once
    var sent = store('sl_pop_sent') === '1' || location.hash === '#sl-pop-form';
    if (sent) {
      store('sl_pop_sent', '0');
      var ok = dlg.querySelector('[data-sl-pop-success]') || /customer_posted=true/.test(location.search);
      if (ok) store(KEY_SUB, '1');
      if (ok || dlg.querySelector('[data-sl-pop-error]')) { open(); return; }
    }
    if (design) return; // never pop up by itself inside the theme editor
    if (store(KEY_SUB) === '1') return;
    var last = Number(store(KEY_SEEN) || 0);
    if (last && Date.now() - last < days * 864e5) return;

    var done = false;
    function trigger() { if (done) return; done = true; window.removeEventListener('scroll', onScroll); open(); }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.5) trigger();
    }
    setTimeout(trigger, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    if (el.__sl) return;
    el.__sl = true;
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.hidden = true; return; }
    var hide = el.getAttribute('data-hide') === 'true';
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    var clock = el.querySelector('.sl-cd__clock'), over = el.querySelector('[data-over]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left <= 0) {
        clearInterval(t);
        if (hide && !window.Shopify?.designMode) { el.hidden = true; return; }
        if (clock) clock.hidden = true;
        if (over) over.hidden = false;
        return;
      }
      var sec = Math.floor(left / 1000);
      d.textContent = pad(Math.floor(sec / 86400));
      h.textContent = pad(Math.floor(sec % 86400 / 3600));
      m.textContent = pad(Math.floor(sec % 3600 / 60));
      s.textContent = pad(sec % 60);
    }
    var t = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Shop the look ---------- */
  function closeAllSpots(except) {
    document.querySelectorAll('.sl-look__dot[aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.sl-look__dot');
    if (dot) {
      var openNow = dot.getAttribute('aria-expanded') !== 'true';
      closeAllSpots(dot);
      dot.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      var p = document.getElementById(dot.getAttribute('aria-controls'));
      if (p) p.hidden = !openNow;
      return;
    }
    if (!(e.target.closest && e.target.closest('.sl-look__pop'))) closeAllSpots(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllSpots(null); });

  /* ---------- Complete-the-look offer (top <-> short, 10% off) ---------- */
  // Horizon announces cart changes with Shopify's standard cart event; listen to the same one.
  var evMod = null;
  function stdEvents() {
    if (!evMod) evMod = import('@shopify/events')
      .catch(function () { return import('https://cdn.shopify.com/storefront/standard-events.js'); })
      .catch(function () { return null; });
    return evMod;
  }
  var TOPS = ['T-Shirts', 'Mens Shirts', 'Tops'], BOTTOMS = ['Shorts', 'Trunks', 'Bottoms'];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function drawerPanel() { return document.querySelector('theme-drawer#cart-drawer[open] dialog'); }
  function wide() { return window.matchMedia('(min-width: 990px)').matches; }
  function pairSeen(pid, set) {
    var k = 'sl_pair_seen_' + pid;
    try { if (set) sessionStorage.setItem(k, '1'); return sessionStorage.getItem(k) === '1'; } catch (e) { return false; }
  }
  function setupPair(el) {
    function hide() { try { el.close(); } catch (e) { el.removeAttribute('open'); } }
    el.querySelectorAll('[data-sl-pair-close]').forEach(function (b) { b.addEventListener('click', hide); });
    el.addEventListener('click', function (e) { if (e.target === el) hide(); });   // tap on the dimmed background
    el.addEventListener('close', function () {
      var panel = drawerPanel();
      if (panel && wide()) import('@theme/focus').then(function (m) { if (m.trapFocus) m.trapFocus(panel); }).catch(function () {});
    });
    el.__hide = hide;
  }
  function showPair(el) {
    if (!el.isConnected || el.open) return;
    // On computers the cart drawer keeps keyboard focus inside itself; pause that while the offer is up.
    if (wide() && drawerPanel()) import('@theme/focus').then(function (m) { if (m.removeTrapFocus) m.removeTrapFocus(); }).catch(function () {});
    try { el.showModal(); } catch (e) { el.setAttribute('open', ''); }
  }
  var pairBusy = false, lastAddAt = 0;
  function sideOf(t) { return TOPS.indexOf(t) > -1 ? 'top' : (BOTTOMS.indexOf(t) > -1 ? 'bottom' : ''); }
  // How many times the offer was shown for a product this visit (max 2: first chance + second chance)
  function pairCount(pid, inc) {
    var k = 'sl_pair_n_' + pid, n = 0;
    try { n = Number(sessionStorage.getItem(k) || 0); if (inc) sessionStorage.setItem(k, String(n + 1)); } catch (e) {}
    return n;
  }
  function markDone() {
    var open = document.getElementById('sl-pair');
    if (!open || !open.open) return;
    open.classList.add('is-done');
    var b = open.querySelector('.sl-pair__badge'); if (b) b.textContent = '10% off ✓';
    var t = open.querySelector('.sl-pair__title'); if (t) t.textContent = 'Nice! 10% comes off at checkout';
    setTimeout(function () { if (open.__hide) open.__hide(); }, 3000);
  }
  // Try candidates (cart lines) in order until the store says one qualifies, then show the offer for it.
  function tryOffer(cands) {
    if (pairBusy) return;
    var cur = document.getElementById('sl-pair');
    if (cur && cur.open) return;
    var seen = {}, list = [];
    cands.forEach(function (it) { if (it && sideOf(it.product_type) && !seen[it.product_id]) { seen[it.product_id] = 1; list.push(it); } });
    list = list.filter(function (it) { return pairCount(it.product_id) < 2; }).slice(0, 3);
    if (!list.length) return;
    pairBusy = true;
    (function next(i) {
      if (i >= list.length) { pairBusy = false; return; }
      var item = list[i];
      // The store decides: regular price, men's/women's, and whether the cart already has the matching piece
      var url = root + 'products/' + item.handle + '?section_id=sl-pair';
      var th = window.Shopify && window.Shopify.theme;
      if (th && th.id && th.role && th.role !== 'main') url += '&preview_theme_id=' + th.id;   // preview: ask the preview theme
      nativeFetch.call(window, url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sl-pair]');
          if (!fresh) return next(i + 1);
          pairBusy = false;
          var old = document.getElementById('sl-pair'); if (old) old.remove();
          fresh = document.importNode(fresh, true);
          if (pairCount(item.product_id) === 1) {                 // they passed the first time
            var badge = fresh.querySelector('.sl-pair__badge');
            if (badge) badge.textContent = 'We believe in second chances';
          }
          document.body.appendChild(fresh);
          setupPair(fresh);
          pairCount(item.product_id, true);
          setTimeout(function () { showPair(fresh); }, 700);   // let the cart drawer slide in first
        })
        .catch(function () { next(i + 1); });
    })(0);
  }
  // First chance: right after something is added (from any button on any page)
  function onCartAdd(d) {
    d = d || {};
    if (d.didError) return;
    if (d.source === 'sl-pair') { markDone(); return; }
    lastAddAt = Date.now();
    var items = d.items || [], item = null;
    if (d.variantId) item = items.filter(function (it) { return String(it.variant_id) === String(d.variantId); })[0];
    if (!item || !sideOf(item.product_type)) return;
    tryOffer([item]);
  }
  // Second chance: when they open the cart (drawer or cart page) and still don't have the pair
  function onCartOpen() {
    if (Date.now() - lastAddAt < 4000) return;   // the add just showed it
    nativeFetch.call(window, root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { tryOffer(cart.items || []); })
      .catch(function () {});
  }
  var nativeFetch = window.fetch;
  var pairListening = false;
  function initPair() {
    if (pairListening || !nativeFetch) return;
    pairListening = true;
    window.slPairDone = function () { onCartAdd({ source: 'sl-pair' }); };
    document.addEventListener('theme-drawer:open', function (e) {
      if (e.target && e.target.id === 'cart-drawer') setTimeout(onCartOpen, 500);
    });
    if (/\/cart\/?$/.test(location.pathname)) setTimeout(onCartOpen, 900);
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/.test(url) && !window.__slOfferAdd) {
          var vid = null, body = init && init.body;
          try {
            if (typeof FormData !== 'undefined' && body instanceof FormData) vid = body.get('id');
            else if (typeof body === 'string') { var j = JSON.parse(body); vid = j.id || (j.items && j.items[0] && j.items[0].id); }
          } catch (e) {}
          p.then(function (r) {
            if (!r || !r.ok) return;
            return nativeFetch.call(window, root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
              .then(function (r2) { return r2.json(); })
              .then(function (cart) {
                var items = cart.items || [];
                onCartAdd({ items: items, variantId: vid || (items[0] && items[0].variant_id) });
              });
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function initAll() {
    initPair();
    initPopup(document.querySelector('[data-sl-pop]'));
    document.querySelectorAll('[data-sl-countdown]').forEach(initCountdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', function (e) {
    var dlg = e.target && e.target.querySelector && e.target.querySelector('[data-sl-pop]');
    if (dlg) { initPopup(dlg); try { dlg.show(); } catch (x) {} }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var dlg = e.target && e.target.querySelector && e.target.querySelector('[data-sl-pop]');
    if (dlg && dlg.open) { try { dlg.close(); } catch (x) {} }
  });
})();
